import { ENVIRONMENT_TYPE } from "./common";

const ENVIRONMENT = {
  environment: process.env.REACT_APP_ENVIRONMENT || ENVIRONMENT_TYPE.DEV,
  ENDPOINT: process.env.REACT_APP_ENDPOINT || "https://api-dev.zenvoya.ai",
  recommendedTripsURL: process.env.REACT_APP_RECOMMENDED_TRIPS_URL || "",
  /**
   * Origin of the traveller app (app-frontend) embedded by TravelAppFrame.
   *
   * Its own variable rather than reusing recommendedTripsURL: that one names a
   * specific feature's link target, and overloading it would make a change to
   * either silently move the other.
   */
  travelAppURL:
    process.env.REACT_APP_TRAVEL_APP_URL || process.env.REACT_APP_RECOMMENDED_TRIPS_URL || "",
  ENCRYPTION_KEY: process.env.REACT_APP_ENCRYPTION_KEY || "",
  APP_URL: process.env.REACT_APP_APP_URL || "",
  API_KEY: process.env.REACT_APP_API_KEY || "",
};

const {
  ENDPOINT,
  recommendedTripsURL,
  travelAppURL,
  ENCRYPTION_KEY,
  environment,
  APP_URL,
  API_KEY,
} = ENVIRONMENT;

export {
  ENDPOINT,
  recommendedTripsURL,
  travelAppURL,
  ENCRYPTION_KEY,
  environment,
  APP_URL,
  API_KEY,
};
